import { render, staticRenderFns } from "./form_add_novelties_component.vue?vue&type=template&id=3ed5fd2e&scoped=true"
import script from "./form_add_novelties_component.vue?vue&type=script&lang=js"
export * from "./form_add_novelties_component.vue?vue&type=script&lang=js"
import style0 from "./form_add_novelties_component.vue?vue&type=style&index=0&id=3ed5fd2e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed5fd2e",
  null
  
)

export default component.exports